import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesPedidos {
  ler: boolean;
  criar: boolean;
  atualizar: boolean;
}

/**
 * Espelho, no frontend, do grant real de RBAC do recurso `pedidos`
 * (`apps/api/src/modules/pedidos/pedidos.routes.ts`): `admin` tem as 3
 * ações; `financeiro`/`producao`/`suporte` só `ler` — já concedido
 * desde a migration `004` (Sprint 2), não uma seed nova da Sprint 4;
 * `marketing`/`parceiros` não têm nenhuma. Sem `excluir`: o recurso
 * `pedidos` nunca teve essa ação (pedido nunca é excluído, só
 * cancelado — `PRODUCT.md`, 3.2). Usado apenas para decidir o que
 * mostrar na UI — a autorização real é sempre revalidada pelo backend.
 */
export function permissoesPedidos(papel: PapelUsuario): PermissoesPedidos {
  if (papel === 'admin') {
    return { ler: true, criar: true, atualizar: true };
  }
  if (papel === 'financeiro' || papel === 'producao' || papel === 'suporte') {
    return { ler: true, criar: false, atualizar: false };
  }
  return { ler: false, criar: false, atualizar: false };
}
